export default __webpack_public_path__ + "static/media/zel-qr_white.fd0bd256.svg";